export var Product;
(function (Product) {
    Product["ResiLite"] = "resilite";
    Product["KeraLite"] = "keralite";
    Product["ElastiLite"] = "elastilite";
    Product["SeaLite"] = "sealite";
    Product["CollaLite"] = "collalite";
    Product["LamiLite"] = "lamilite";
})(Product || (Product = {}));
